// Shared utilities for schedule UIs (employee + admin).
export const DAYS = [
  { key: "mon", label: "Monday" },
  { key: "tue", label: "Tuesday" },
  { key: "wed", label: "Wednesday" },
  { key: "thu", label: "Thursday" },
  { key: "fri", label: "Friday" },
  { key: "sat", label: "Saturday" },
  { key: "sun", label: "Sunday" },
];

export function emptyAvailability() {
  const a = {};
  DAYS.forEach((d) => { a[d.key] = { available: false, start: "09:00", end: "17:00" }; });
  return a;
}

export function defaultWeekday() {
  const a = {};
  DAYS.forEach((d, i) => {
    a[d.key] = { available: i < 5, start: "09:00", end: "17:00" };
  });
  return a;
}

/** Format a Date as local YYYY-MM-DD (timezone-safe, never rolls into previous day). */
export function toLocalISO(d) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/** Returns the Monday (YYYY-MM-DD, local time) of the week containing `date`. */
export function mondayOf(date) {
  const d = new Date(date);
  const day = d.getDay(); // 0 Sun ... 6 Sat
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return toLocalISO(d);
}

/** Shift a Monday ISO string by N weeks (can be negative). */
export function shiftWeek(weekStart, weeks) {
  const d = new Date(weekStart + "T00:00:00");
  d.setDate(d.getDate() + weeks * 7);
  return toLocalISO(d);
}

/** Current week's Monday in local time. */
export function currentMonday() {
  return mondayOf(new Date());
}

export function formatWeekLabel(weekStart) {
  try {
    const m = new Date(weekStart + "T00:00:00");
    const sun = new Date(m); sun.setDate(m.getDate() + 6);
    const opts = { month: "short", day: "numeric" };
    return `${m.toLocaleDateString(undefined, opts)} – ${sun.toLocaleDateString(undefined, { ...opts, year: "numeric" })}`;
  } catch { return weekStart; }
}

/** Generate next N Mondays (including this week's Monday). */
export function nextMondays(count = 4) {
  const out = [];
  const start = currentMonday();
  for (let i = 0; i < count; i++) {
    out.push(shiftWeek(start, i));
  }
  return out;
}
